import { MenuItem } from "@mui/material"

export const RESOLUTION_FILTER_ANY = "any"
export const RESOLUTION_FILTER_DEFAULT_ONLY = "default"
export const RESOLUTION_FILTER_CONDITIONAL_ONLY = "conditional"
// FIQ-2457: tasks routed by a skill map schedule assignment
export const RESOLUTION_FILTER_ASSIGNMENT_ONLY = "assignment"

/**
 * Every option of the per-task Resolution filter, for the server-backed task list and the
 * inline breakdown dialog alike, so both offer the same choices. An array for the same
 * reason as buildResolutionFilterOptions below.
 *
 * @param {{ conditionalTradesOn: boolean, scheduleAssignmentsOn: boolean, conditionalNames: string[] }} options
 * @returns {JSX.Element[]}
 */
export function buildResolutionMenuItems({ conditionalTradesOn, scheduleAssignmentsOn, conditionalNames }) {
    const items = [
        <MenuItem key={RESOLUTION_FILTER_ANY} value={RESOLUTION_FILTER_ANY}>
            Resolution: any
        </MenuItem>,
        <MenuItem key={RESOLUTION_FILTER_DEFAULT_ONLY} value={RESOLUTION_FILTER_DEFAULT_ONLY}>
            Resolution: default only
        </MenuItem>,
    ]
    if (conditionalTradesOn) {
        items.push(
            <MenuItem key={RESOLUTION_FILTER_CONDITIONAL_ONLY} value={RESOLUTION_FILTER_CONDITIONAL_ONLY}>
                Resolution: conditional only
            </MenuItem>
        )
    }
    if (scheduleAssignmentsOn) {
        items.push(
            <MenuItem key={RESOLUTION_FILTER_ASSIGNMENT_ONLY} value={RESOLUTION_FILTER_ASSIGNMENT_ONLY}>
                Resolution: schedule assignment only
            </MenuItem>
        )
    }
    if (conditionalTradesOn) items.push(...buildResolutionFilterOptions(conditionalNames))
    return items
}

/**
 * Named-conditional options for the per-task Resolution filter, returned as a flat
 * array of MenuItem elements.
 *
 * These deliberately do NOT go through <Repeat>, which the codebase otherwise
 * requires for lists. MUI's Select enumerates its DIRECT children with
 * React.Children.map and clones each one to inject role="option", the item click
 * handler and data-value. React.Children.map flattens arrays, so an array of
 * MenuItems is cloned per item and works; a <Repeat> element is cloned ONCE as a
 * single opaque child, so its rendered MenuItems get no option role, no click
 * handler and no per-item value, leaving them visible but unselectable. A wrapper
 * component cannot fix that either, because MUI never sees the individual items.
 */
export function buildResolutionFilterOptions(conditionalNames) {
    return (conditionalNames ?? []).map(toOption)

    function toOption(name) {
        return (
            <MenuItem key={name} value={name} data-cy="resolution-filter-condition">
                Resolution: {name}
            </MenuItem>
        )
    }
}
